import { Box } from '@material-ui/core';
import AsyncPhotoEditorV2 from 'components/AsyncPhotoEditorV2/AsyncPhotoEditorV2';
import AvatarSkeleton from 'components/Avatar/AvatarSkeleton/AvatarSkeleton';
import React, { useMemo, useRef, useState } from 'react';
import { useQueryClient } from 'react-query';
import useImageLoader from 'shared/hooks/useImageLoader';
import { mediaService } from 'shared/services/mediaService';
import { profileService } from 'shared/services/profileService';
import { talentService } from 'shared/services/talentService';
import { uploadService } from 'shared/services/uploadService';
import { useDebounce } from 'use-debounce';
import { useStyles } from './Dashboard.styles';

interface Props {
  src: string | undefined;
}
const { updateMe } = talentService();
const { getMediaList, getMediaTags } = mediaService();
const { patchMultipleMedia, patchMediaTags, uploadMedia } = uploadService();
const { getProfiles } = profileService();

const NewImage: React.FC<Props> = ({ src }) => {
  const { imageLoaded, error } = useImageLoader(src || '');
  const [queryValue] = useDebounce('', 500);
  const { data: mediaData, isLoading: isMediaDataLoading } = getMediaList({ file_type: 'image', media_bin: true });
  const { mutateAsync: patchMultipleMediaAsync } = patchMultipleMedia();
  const { mutateAsync: patchMediaTagsAsync } = patchMediaTags();
  const { data: mediaTags, isLoading: fetchingTags } = getMediaTags(queryValue);
  const { mutateAsync: meUpdate } = updateMe();
  const { mutateAsync: uploadMediaMutateAsync } = uploadMedia();
  const queryClient = useQueryClient();
  const classes = useStyles();
  const [showEditor, setshowEditor] = useState(false);
  const [files, setFiles] = useState<File[]>([]);
  const inputFile = useRef<HTMLInputElement>(null);
  const { data: dataProfiles } = getProfiles();
  const primaryProfile = dataProfiles?.data.filter((profile) => profile.attributes.primary);
  const profileId = useMemo(() => {
    return primaryProfile?.length === 1 ? primaryProfile[0].id : undefined;
  }, [primaryProfile]);
  const changeHandler = (e: any) => {
    const file = e.target.files[0];
    if (file) setshowEditor(true);
    setFiles([file]);
  };

  const handleOpenFileWindow = () => {
    if (inputFile.current) {
      inputFile.current.click();
    }
  };

  return (
    <Box style={{ position: 'relative' }}>
      <div style={{ height: 0, width: 0, overflow: 'hidden' }}>
        <input
          ref={inputFile}
          id="contained-input-file"
          type="file"
          accept="image/*, .heic, .heif"
          onClick={(e) => {
            e.stopPropagation();
          }}
          onChange={(e) => {
            changeHandler(e);
          }}
        />
      </div>
      <Box component="div" className={classes.imgContainer} style={{ maxWidth: 125, minWidth: 125, height: 160 }}>
        {/* I comment the functionality of updating and adding headshot for now, we may need this later */}
        <Box
        // onClick={handleOpenFileWindow}
        >
          {/* {src ? (
            <CameraCont className="camera-cont">
              <Typography
                style={{
                  whiteSpace: 'normal',
                  fontSize: 10,
                  zIndex: 2,
                  position: 'absolute',
                  bottom: 0,
                  color: 'white',
                  fontWeight: 500,
                  marginBottom: 10,
                  background: COLORS.PRIMARY,
                  borderRadius: 8,
                  padding: '2px 5px',
                  border: '1px solid gray',
                }}
              >
                Update Headshot
              </Typography>
            </CameraCont>
          ) : (
            <CameraCont className="camera-cont">
              <Typography
                style={{
                  whiteSpace: 'normal',
                  fontSize: 10,
                  zIndex: 2,
                  position: 'absolute',
                  bottom: 0,
                  color: 'white',
                  fontWeight: 500,
                  margin: 5,
                  background: COLORS.PRIMARY,
                  borderRadius: 8,
                  padding: '2px 5px',
                  border: '1px solid gray',
                }}
              >
                Add your headshot
              </Typography>
            </CameraCont>
          )} */}
          {/* <img
            src={src ? `${src}/111x146` : '/assets/user.png'}
            className={classes.img}
            style={{ position: 'absolute' }}
          /> */}
          <div className={classes.img}>
            {imageLoaded && src ? (
              <img
                src={src && !error ? `${src}/111x146` : '/assets/user.png'}
                style={{ position: 'absolute', width: '100%', height: '100%', borderRadius: 5 }}
              />
            ) : src ? (
              <AvatarSkeleton style={{ width: '100%', height: '100%', border: 'none', borderRadius: 5 }} />
            ) : (
              <img
                src={'/assets/user.png'}
                style={{ position: 'absolute', width: '100%', height: '100%', borderRadius: 5 }}
              />
            )}
          </div>
        </Box>
      </Box>
      {showEditor && files && mediaTags && !fetchingTags && mediaData && !isMediaDataLoading && (
        <>
          <AsyncPhotoEditorV2
            enableUndo={true}
            variant="default"
            {...{
              patchMultipleMediaAsync,
              patchMediaTagsAsync,
              uploadMediaMutateAsync,
            }}
            profileId={profileId}
            mediaData={mediaData.data}
            mediaTags={mediaTags.data}
            show={showEditor}
            images={files}
            close={() => {
              setshowEditor(false);
              queryClient.invalidateQueries(['profile_media', profileId, { file_type: 'image' }]);
              queryClient.invalidateQueries(['media', { file_type: 'image' }]);
              queryClient.invalidateQueries(['profile', profileId]);
            }}
            onSuccessImageUpdate={() => {
              queryClient.invalidateQueries(['profile_media', profileId, { file_type: 'image' }]);
              queryClient.invalidateQueries(['media', { file_type: 'image' }]);
              queryClient.invalidateQueries(['profile', profileId]);
            }}
            onSuccessImageUpload={() => {
              queryClient.invalidateQueries(['profile_media', profileId, { file_type: 'image' }]);
              queryClient.invalidateQueries(['media', { file_type: 'image' }]);
              queryClient.invalidateQueries(['profile', profileId]);
            }}
            onPostUploadImageAfterProfileAttachment={(data: any) => {
              meUpdate(
                { medium_id: data.data.id },
                {
                  onSuccess: () => {
                    queryClient.invalidateQueries('me');
                  },
                },
              );
            }}
          />
        </>
      )}
    </Box>
  );
};

export default NewImage;
